import { createApp } from 'vue';

// Import components
import ProductListing from './components/product-listing.vue';
import ProductCompare from './components/product-compare.vue';
import Svg from './components/svg.vue';
import GenericListing from './components/generic-listing.vue';
import DocumentListing from './components/document-listing.vue';
import { BootstrapIconsPlugin  } from 'bootstrap-icons-vue';

// Initialize application
createApp({
  components: {
    'product-listing': ProductListing,
    'icon': Svg
  }
}).mount('#product-listing-vue');

createApp({
  components: {
    'product-compare': ProductCompare,
    'icon': Svg
  }
}).mount('#product-compare-vue')

createApp({
  components: {
    'generic-listing': GenericListing,
    'icon': Svg
  }
}).mount('.generic-listing-vue');

createApp({
  components: {
    'document-listing': DocumentListing,
    'icon': Svg
  }
}).use(BootstrapIconsPlugin).mount('.document-listing-vue');